export const TEST_ID = 'stateComplianceModal';

export const UNLICENSED_WARNING_TEST_ID = 'stateComplianceModalUnlicensedWarning';

export const SHIPPED_STATES = ['CA', 'MN', 'NY'] as const;

export const COMING_SOON_STATES = [
    'CT',
    'DC',
    'HI',
    'IA',
    'MA',
    'MD',
    'ME',
    'ND',
    'NJ',
    'NV',
    'OR',
    'VT'
] as const;

/**
 * Maps state codes to their translation key in `useTranslation()`.
 * Resolved at render time via `translations[key]` to keep all user-visible
 * strings in the translations file rather than inline English literals.
 */
export const STATE_TITLE_KEY_MAP: Readonly<Record<string, 'CA_TITLE' | 'MN_TITLE' | 'NY_TITLE'>> = {
    CA: 'CA_TITLE',
    MN: 'MN_TITLE',
    NY: 'NY_TITLE'
};
